import { FileDto, GetFileParams, UploadFileParams } from '@app/models/file';

import { apiService } from '@app/services/api-service';

export abstract class FileApi {
  static async getFile({ id, isAttachment, isPublic, cropSize }: GetFileParams) {
    return apiService.get<Blob>(`/${isPublic ? 'public' : 'private'}/files/${id}`, {
      params: {
        isAttachment,
        cropSize,
      },
      responseType: 'blob',
    });
  }

  static async uploadFile({ formData, config, isPublic }: UploadFileParams) {
    return await apiService.post<FileDto>('/private/files', formData, {
      ...config,
      params: { ...config?.params, isPublic },
    });
  }

  static async deleteFile(fileId: string) {
    return await apiService.delete(`/private/files/${fileId}`);
  }
}
